// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".linkedin-post-preview[data-v-5cd1842d]{box-shadow:0 0 8px rgba(0,0,0,.08);border-radius:10px;border:1px solid #e0dfdc;font-family:Roboto,sans-serif}", ""]);
// Exports
module.exports = exports;
